<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            class="demo-ruleForm"
            label-width="120px"
            label-position="left"
          >
            <el-form-item
              class="el-form-item-update"
              ref="name"
              label="套餐来源："
              prop="name"
              v-if="form.id ? false : true"
            >
              纸质卡
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              ref="name"
              label="套餐来源："
              prop="name"
              v-else
            >
              <el-input v-model="form.cardOldTypeCn" readonly="" placeholder="请输入套餐类型" maxlength="15"></el-input>
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              ref="name"
              label="套餐类型："
              prop="name"
              :rules="$rules.required"
            >
              <el-input v-model="form.name" :disabled="disabled" placeholder="请输入套餐类型" maxlength="15"></el-input>
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              ref="salePrice"
              label="售价："
              prop="salePrice"
              :rules="$rules.money"
            >
              <el-input v-model="form.salePrice" placeholder="请输入售价" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              ref="achievementAmount"
              label="划卡业绩："
              prop="achievementAmount"
              :rules="$rules.money"
            >
              <el-input v-model="form.achievementAmount" placeholder="请输入划卡业绩" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              ref="deductAmount"
              label="提成金额："
              prop="deductAmount"
              :rules="$rules.money"
            >
              <el-input v-model="form.deductAmount" placeholder="请输入提成金额" maxlength="8"></el-input>
            </el-form-item>
          </el-form>
          <div class="paperIndex-info">
              <div>温馨提示：</div>
              <div>套餐类型：例如 688套餐，888套餐等。保存后套餐类型不可修改</div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="back el-icon-back" @click="back"></div>
          <div class="btns">
            <el-button type="primary" class="small-btn" @click="onSubmit">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      form: {},
      columns: [],
      disabled: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.$refs["form"].resetFields();
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        if (org) {
          this.addEditTitle = "编辑纸质套餐";
          this.disabled = true;
          this.$api.get(this.$url.cardOld.gets, {
              id: org.id
            }).then(res => {
              if (res) {
                this.form = res;
              }
            })
        } else {
          this.addEditTitle = "新增纸质套餐";
        }
        this.addEditShow = true;
      });
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    onSubmit() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
            this.$api.post(this.$url.cardOld.saves, this.form).then(res => {
              if (res) {
                this.addEditShow = false;
                this.$refs["form"].clearValidate();
                this.$emit("change", true);
              }
            })
        }
      })
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  height: 100%;
  box-sizing: border-box;
  padding-top: 10px;
  .paperIndex-info {
     color: red;
     font-weight: 700;
     padding: 0 50px;
  }
  /deep/ .el-form-item__content {
    width: 220px;
  }
  /deep/ .el-form {
    padding-bottom: 20px;
    /deep/ .el-form-item {
      background: #fff;
      border-bottom: 1px solid @borderColor;
      padding: 10px 20px;
      margin-bottom: 0;
      &:last-child {
        border-bottom: 0;
      }
    }
    .el-form-item-update {
      padding: 0 20px;
      height: 80px;
      align-items: center;
      display: flex;
      margin: 0;
      justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        // text-align: left;
      }
      /deep/ .el-form-item__content {
        flex: 2;
        text-align: right;
        // display: flex;
        margin-left: 0 !important;
        .el-form-item__error {
          right: 0;
        }
      }
    }
  }
}
</style>